<template>
  <div>
    <div class="d-flex justify-end mb-4">
      <span class="secondaryGray--text text-caption">
        Pregunta {{ preguntaActual }} de {{ totalPreguntas }}
      </span>
    </div>
    <div class="barra-progreso-fondo">
      <div class="barra-progreso-completado primary" :style="{ width: porcentaje + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarraProgreso",
  props: {
    preguntaActual: {
      type: Number,
      required: true,
    },
    totalPreguntas: {
      type: Number,
      required: true,
    },
  },
  computed: {
    porcentaje() {
      if (!this.totalPreguntas) return 0;
      return Math.min(100, (this.preguntaActual / this.totalPreguntas) * 100);
    },
  },
};
</script>

<style scoped>
.barra-progreso-fondo {
  width: 100%;
  height: 8px;
  background-color: #dbe3fb;
  border-radius: 5px;
  overflow: hidden;
}

.barra-progreso-completado {
  height: 100%;
  border-radius: 5px;
  transition: width 0.3s ease;
}

.text-caption {
  font-family: 'MuseoSans' !important;
}
</style>
